/* global config */
import { fetch as fetchPolyfill } from 'whatwg-fetch';

const hostname = config.abeAPI;
const version = 'v1';
const headers = {};

export const request = (path, options = {}) => {
    const requestURL = `${hostname}/api/${version}${path}`;

    const requestOptions = {
        ...options,
        headers,
    };

    return fetchPolyfill(requestURL, requestOptions);
};

export const setHeader = (name, value) => {
    headers[name] = value;
};
